/**
 * A supplier product can be associated to several central products, each association telling
 * whether the product syncs its data from it and whether it is its last active supplier product
 */
const getProductAssociations = ({ productAssociations }) => productAssociations ?? [];

/**
 * Central products left without any active supplier product by the deactivation: they are
 * deactivated as well, which also deactivates their supplier products
 */
export const getProductIdsToDeactivate = (supplierProducts) => [
  ...new Set(
    supplierProducts.flatMap((supplierProduct) =>
      getProductAssociations(supplierProduct)
        .filter(({ isLastActiveSupplierProduct }) => isLastActiveSupplierProduct)
        .map(({ productId }) => productId),
    ),
  ),
];

/**
 * Supplier products to deactivate on their own, the other ones being already deactivated through
 * their central product
 */
export const getSupplierProductIdsToDeactivate = (supplierProducts) =>
  supplierProducts
    .filter(
      (supplierProduct) =>
        !getProductAssociations(supplierProduct).some(
          ({ isLastActiveSupplierProduct }) => isLastActiveSupplierProduct,
        ),
    )
    .map(({ id }) => id);

export default {
  getProductIdsToDeactivate,
  getSupplierProductIdsToDeactivate,
};
